export const DONT_SHOW_VALUE_KEYS = [
  // 商品筛选项
  "global.filter.is_full_service", // 全托管商品
  "product.filter.commission_rate", // 佣金比例
  "product.filter.creator_conversion_ratio", // 达人出单率
  "product.filter.launch_date", // 上架时间

  // 店铺
  "seller.filter.operation_mode", // 成交金额来源
  "seller.filter.is_overseas", // 发货方式

  // 达人筛选项
  // "creator.filter.follower_age", // 粉丝年龄
  "creator.filter.follower_gender", // 粉丝性别
  "creator.filter.follower_language", // 粉丝语言
];

export const EXCLUDE_REFRESH_PATHS = [];

export const CHANNEL_NAME = "global_channel";

export const FALLBACK_KEY = "__broadcast_fallback__";

export const _TAB_BROADCAST_MANAGER_NAME_: string = "tabBroadcastManagerName";

export const CHART_DEFAULT_COLOR = [
  "#0191F8", // FIRST
  "#00D47C", // SECOND
  "#6D27E7", // THIRD
  "#F94B60", // FOURTH
  "#1AC3E9", // FIFTH
  "#CCFF14", // SIXTH
  "#265BCC", // SEVENTH
  "#FFB727", // EIGHTH
  "#A52A2A", // NINTH
  "#666666", // TENTH
];
